// actions/employee-onboarding/responses.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// responses

export function responsesHasErrored(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_HAS_ERRORED',
    hasErrored: bool
  };
}

export function responsesIsLoading(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_IS_LOADING',
    isLoading: bool
  };
}

export function responsesFetchDataSuccess(list) {
  return {
    type: 'ONBOARDING_RESPONSES_FETCH_DATA_SUCCESS',
    list
  };
}

export function responsesFetchData(host, params) {
  return (dispatch) => {
    dispatch(responsesIsLoading(true));
    dispatch(responsesHasErrored(false));
    var path = 'approve/responses';
    if (params) {
      path = path + '?approve_id=' + params.approve + '&deny_id=' + params.deny;
    }
    
    fetch(host + path, {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(responsesFetchDataSuccess(result));
            dispatch(responsesHasErrored(false));
            dispatch(responsesIsLoading(false));
            if (result && result.Items && result.Items.length > 0) {
              PubSub.publish('employee.responses.first', result.Items[0]);
            }
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(responsesHasErrored(true));
            dispatch(responsesIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(responsesHasErrored(true));
      dispatch(responsesIsLoading(false));
    });
  };
}

// responses_add

export function responsesAddHasErrored(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_ADD_HAS_ERRORED',
    hasErrored: bool
  };
}

export function responsesAddIsLoading(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_ADD_IS_LOADING',
    isLoading: bool
  };
}

export function responsesAddFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_RESPONSES_ADD_FETCH_DATA_SUCCESS',
    data
  };
}

export function responsesAddFetchData(host, params) {
  return (dispatch) => {
    dispatch(responsesAddIsLoading(true));
    dispatch(responsesAddHasErrored(false));
    fetch(host + 'admin/response_add', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(responsesAddFetchDataSuccess(result));
            dispatch(responsesAddHasErrored(false));
            dispatch(responsesAddIsLoading(false));
            PubSub.publish('employee.responses.reload', true);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(responsesAddHasErrored(true));
            dispatch(responsesAddIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(responsesAddHasErrored(true));
      dispatch(responsesAddIsLoading(false));
    });
  };
}

// responses_delete

export function responsesDeleteHasErrored(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_DELETE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function responsesDeleteIsLoading(bool) {
  return {
    type: 'ONBOARDING_RESPONSES_DELETE_IS_LOADING',
    isLoading: bool
  };
}

export function responsesDeleteFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_RESPONSES_DELETE_FETCH_DATA_SUCCESS',
    data
  };
}

export function responsesDeleteFetchData(host, params) {
  return (dispatch) => {
    dispatch(responsesDeleteIsLoading(true));
    dispatch(responsesDeleteHasErrored(false));
    fetch(host + 'admin/response_delete', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(responsesDeleteFetchDataSuccess(result));
            dispatch(responsesDeleteHasErrored(false));
            dispatch(responsesDeleteIsLoading(false));
            PubSub.publish('employee.responses.reload', true);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(responsesDeleteHasErrored(true));
            dispatch(responsesDeleteIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(responsesDeleteHasErrored(true));
      dispatch(responsesDeleteIsLoading(false));
    });
  };
}